/**
 * Frames that arrive on the wall without focus: an agent presented them with
 * `visibility: "keep"` on the web. `flashWallArrival` announces them to the
 * listeners `onWallArrival` registered; a wall that subscribes flashes
 * their cards. The event carries the ids only, so the sender never reads
 * wall state, and without a listener nothing is drawn.
 */

export interface WallArrival {
  frameIds: readonly string[];
}

type WallArrivalListener = (arrival: WallArrival) => void;

const listeners = new Set<WallArrivalListener>();

/** Announce frames that should flash on the wall. */
export function flashWallArrival(frameIds: readonly string[]): void {
  if (frameIds.length === 0) return;
  const arrival: WallArrival = { frameIds: [...frameIds] };
  for (const listener of [...listeners]) listener(arrival);
}

/** Subscribe to wall arrivals; returns the unsubscribe. */
export function onWallArrival(listener: WallArrivalListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
